import React, { useContext, useState, useEffect } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { TYPE } from '../../../theme'
import { Text } from 'rebass'
import axios from 'axios'

// components
import Row, { AutoRow } from '../../../components/Row'
import { ButtonConfirmed } from '../../../components/Button'
import Loader from '../../../components/Loader'
import UpLoadFiles from './UpLoadFiles'
import LaunchInput from './LaunchInput'
import SortPets from '../../Pet/components/SortPets'
import Modal from '../../../components/bakery/Modal'

// constants
import { imgErr, editionExp, linkExp, mintType, MintOptions, AudioInfo, ImageInfo, VideoInfo } from '../../../constants/artwork'

// hooks
import { useActiveWeb3React } from '../../../hooks'
import { useAddPopup } from '../../../state/application/hooks'
import { useWalletModalToggle } from '../../../state/application/hooks'
import { useBakeryArtworkNFTContract } from '../../../hooks/commonNft/useBakeryArtworkNFTContract'
import useModal from '../../../hooks/bakery/useModal'
import { useMintAddress } from '../../../hooks/commonNft/useContract'

// service
import { getSignature} from '../../../service/appService'
import { createArtworks } from '../../../service/nft'
import { getArtistInfo } from '../../../service/user'

import { mintBakeryArtwork, mintBakeryArtworkV2 } from '../../../sushi/utils'
import { deepCopy } from '../../../utils/func'
import { MARKETTYPE } from '../../../constants/bakery/nft'

axios.defaults.timeout = 600000
const CancelToken = axios.CancelToken
let cancelImg: any
let cancelAudio: any

const LaunchWrap = styled.div`
  padding: 40px 124px;
  width: 840px;
  height: auto;
  background: ${({ theme }) => theme.bsBg10};
  box-shadow: 0px 2px 10px ${({theme}) => !theme.darkMode ? 'rgba(171, 133, 115, 0.16)' : 'rgba(171, 133, 115, 0)'};
  border-radius: 32px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 0 10px;
    padding: 20px 24px;
    width: auto;
  `}
`
const FormItem = styled.div<{ width?: string; height?: string }>`
  position: relative;
  width: ${({ width }) => (width ? width : '100%')};
  min-height: ${({ height }) => (height ? height : '108px')};
  .errShow {
    height: 20px;
  }
`
// const TextareaLimit = styled.div`
//   position: absolute;
//   bottom: 35px;
//   right: 24px;
//   font-family: Baloo Da;
//   font-size: 12px;
//   color: ${({ theme }) => theme.bsText10};
//`
const LaunchUpload = styled(Row)<{ pad?: string }>`
  padding-bottom: ${({ pad }) => (pad ? pad : '0px')};
  .inputFile {
    display: none;
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
    width: 100%;
    
  `}
`
const Button = styled(ButtonConfirmed)`
  border: none;
  font-size: 14px;
  width: 244px;
  height: 40px;
  border-radius: 10px;
  text-align: cneter;
  padding: 0;
`
const MintCheckbox = styled(Row)`
  margin-bottom: 30px;
  align-items: flex-start;
  justify-content: center;
  .tui-checkbox:focus {
    outline: none;
  }
  .tui-checkbox:checked {
    background: ${({theme}) => theme.bsBg4};
    border: solid 0px ${({theme}) => theme.bsBorder2};
  }
  .tui-checkbox {
    width: 19px;
    height: 19px;
    min-width: 19px;
    background-color: ${({theme}) => theme.bsBg19};
    border: solid 1px ${({theme}) => theme.bsBorder2};
    padding: 0;
    position: relative;
    display: inline-block;
    vertical-align: top;
    -webkit-appearance: none;
    -webkit-user-select: none;
    user-select: none;
    -webkit-transition: background-color ease 0.1s;
    transition: background-color ease 0.1s;
    border-radius: 4px;
    cursor: pointer;
  }
  .tui-checkbox:checked::after {
    content: '';
    top: 5px;
    left: 5px;
    position: absolute;
    background: transparent;
    border: ${({theme}) => theme.white} solid 2px;
    border-top: none;
    border-right: none;
    height: 4px;
    width: 7px;
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  label {
    margin-left: 8px;
    line-height: 20px;
    max-width: 402px;
    font-size: 14px;
    color: ${({ theme }) => theme.bsText3};
    font-weight: bold;
    cursor: pointer;
  }
`
const SymbolIcon = styled(Text)`
  position: absolute;
  top: 45px;
  right: 15px;
  color: ${({ theme }) => theme.bsText2};
  font-weight: 800;
`

export default function Mint({info, type}: {info: any, type: string}) {
  const theme = useContext(ThemeContext)
  let defaultInfo: any = {...deepCopy(info)}
  const { account, chainId, library } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const [artworkInfo, setArtworkInfo] = useState(defaultInfo)
  // const [briefNum, setBriefNum] = useState(0)
  const [submit, setSubmit] = useState(true)
  const bakeryArtworkNft = useBakeryArtworkNFTContract(type)
  const [resloading, setResloading] = useState(false)

  const [fileType, setFileType] = useState(1)

  const mintAddress: any = useMintAddress()
  const [canMint, setCanMint] = useState(true)
  useEffect(() => {
    if (account && mintAddress && type === 'RACANFT') {
      setCanMint(mintAddress.includes(account))
    }
  }, [account, chainId, mintAddress, type])

  const [haveRead, setHaveRead] = useState(false)
  const handleCheckboxChange = async () => {
    setHaveRead(!haveRead)
  }

  const [nameHave, setNameHave] = useState(false)
  // 获取信息
  const getUserInfo = () => {
    getArtistInfo(chainId as number, {address: account}, (err: any, d: any) => {
      let info = {...artworkInfo}
      info.artistName.errShow = false
      if (!err && d.code === 0) {
        if (d.data.hasOwnProperty('nick')) {
          info.artistName.text = d.data.nick
          setNameHave(true)
        }
      } else {
        info.artistName.text = ''
        setNameHave(false)
      }
      setArtworkInfo(info)
    })
  }

  useEffect(() => {
    if (account) {
      getUserInfo()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account])

  const [curTab, setCurTab] = useState(MintOptions[0])
  const upTab = (d: any) => {
    setCurTab(d)
    setFileType(d.key)
    let artworkImage = {...ImageInfo}
    let data: any = {}
    for (const key in artworkInfo) {
      if (Object.prototype.hasOwnProperty.call(artworkInfo, key)) {
        if (key !== 'artworkAudio' && key !== 'artworkVideo') {
          if (key === 'artworkImage') {
            data[key] = artworkImage
          } else {
            const element = artworkInfo[key]
            data[key] = element
          }
        }
      }
    }
    if (d.key === 3) {
      let artworkVideo = {...VideoInfo}
      data['artworkVideo'] = artworkVideo
    } else if (d.key === 4) {
      let artworkAudio = {...AudioInfo}
      data['artworkAudio'] = artworkAudio
    }
    setArtworkInfo(data)
  }

  // 检查信息是否完整
  useEffect(() => {
    checkInfo(artworkInfo, haveRead)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [artworkInfo, haveRead])

  const inputChange = (type: any, e: any) => {
    const info = { ...artworkInfo }
    if (type === 'edition' || type === 'profileLink') {
      info[type].text = e.target.value.trim()
    } else {
      info[type].text = e.target.value
    }
    inputBlur(type)
  }

  const inputBlur = (type: any) => {
    const info = { ...artworkInfo }
    if (info[type].text.trim()) {
      info[type].errShow = false
      const val = info[type].text
      if (type === 'royalties') {
        if (val < 0 || val > 50) {
          info[type].err = 'Enter 0-50'
          info[type].errShow = true
        } else {
          info[type].err = 'Enter the Royalties'
          info[type].errShow = false
        }
      }
      if (type === 'edition') {
        if (!editionExp.test((info[type].text))) {
          info[type].err = 'example: 1/6'
          info[type].errShow = true
        } else {
          info[type].err = 'Enter the Edition'
          info[type].errShow = false
        }
      }
      if (type === 'profileLink') {
        if (!linkExp.test((info[type].text))) {
          info[type].err = 'Invalid profile link'
          info[type].errShow = true
        } else {
          info[type].err = ''
          info[type].errShow = false
        }
      }
    } else {
      if (type === 'edition') {
        info[type].err = 'Enter the Edition'
      }
      info[type].errShow = true
      if (type === 'profileLink') {
        info[type].err = ''
        info[type].errShow = false
      }
    }
    setArtworkInfo(info)
  }

  const uploadImg = (type: string) => {
    let dom: any = null
    if (type === 'artworkVideo') {
      if (!artworkInfo.artworkVideo.progressBar.complete) return
      dom = document.getElementById('videoFile')
    } else if (type === 'artworkAudio') {
      if (!artworkInfo.artworkAudio.progressBar.complete) return
      dom = document.getElementById('audioFile')
    } else {
      if (!artworkInfo.artworkImage.progressBar.complete) return
      dom = document.getElementById('imgFile')
    }
    dom.value = ''
    dom.click()
  }

  const setImgInfo = (type: any, err: any, show: boolean, src?: string, ) => {
    const info = { ...artworkInfo }
    info[type].errShow = show
    info[type].err = err
    info[type].text = src ? src : info[type].text
    setArtworkInfo(info)
  }

  // 校验图片
  const verififyFile = (file: any, type: string) => {
    if (!file) return
    const name = file.name
    if (!/\.(png|jpg|jpeg|gif|mp3|flv|mp4)/i.test(name)) {
      return false
    }
    let curType = type
    if (type === 'artworkImage') {
      if (curTab.key === 3 || curTab.key === 4) {
        curType = 'artworkCover'
      }
    }
    if (file.size > imgErr[curType].size) {
      setImgInfo(type, imgErr[curType].errSize, true)
      return false
    } else {
      setImgInfo(type, imgErr[curType].err, false)
    }
    return true
  }

  // 上传文件
  const uploadIdImg = (e: any, type: string) => {
    const files = e.target.files
    if (!files || !verififyFile(files[0], type)) return
    setProgress({show: true, progress: 0, complete: false}, type)
    const format = files[0].name
      ? files[0].name.split('.').slice(-1)[0]
      : files[0].type.split('/')[1]
    const ready = new FileReader()
    let info = {...artworkInfo}
    if (/\.(png|jpg|jpeg|gif)/i.test(files[0].name)) {
      const img = new Image()
      img.onload = function() {
        getFileSignature(files[0], type, format)
        // setImgInfo(type, imgErr[type].err, false, event.target.result, 1, files[0])
      }
      ready.onload = function(event: any) {
        info.artworkImage.file = event.target.result
        img.src = event.target.result
        setArtworkInfo(info)
      }
    } else if (/\.(mp4|flv)/i.test(files[0].name)) {
      ready.onload = function(event: any) {
        info.artworkVideo.file = event.target.result
        info.artworkVideo.format = format
        setArtworkInfo(info)
        getFileSignature(files[0], type, format)
      }
    } else if (/\.(mp3)/i.test(files[0].name)) {
      ready.onload = function(event: any) {
        getFileSignature(files[0], type, format)
      }
    }
    ready.readAsDataURL(files[0])
  }

  // 获取签名
  const getFileSignature = (file: any, type: string, format: string) => {
    let params  ={
      suffix: format
    }
    getSignature(chainId as number, params, async(err: any, d: any) => {
      if (err) return
      if (d.code !== 0) return
      const url = d.data.url
      const fields = d.data.fields
      var form_data = new FormData()
      Object.keys(fields).forEach((key) => {
        form_data.append(key, fields[key])
      })
      form_data.append('file', file)
      await axios.post(url, form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        },
        cancelToken: new CancelToken(function executor(c) {
          if (type === 'artworkImage') {
            cancelImg = c
          } else {
            cancelAudio = c
          }
        }),
        onUploadProgress: (progressEvent: ProgressEvent) => {
          if (progressEvent.lengthComputable) {
            let progressBar = {
              show: true,
              progress: Number((Number(progressEvent.loaded / progressEvent.total) * 100).toFixed(2) || 0),
              complete: Number(progressEvent.loaded / progressEvent.total) === 1 ? true : false
            }
            setProgress(progressBar, type)
          }
          if (Number(progressEvent.loaded / progressEvent.total) === 1) {
            setImgInfo(type, imgErr[type].err, false, d.data.fileUrl)
          }
        }
      })
    })
  }

  // 取消上传
  const cancelUpload = (type: string) => {
    let progressBar = {
      show: false,
      progress: 0,
      complete: true
    }
    if (type === 'artworkImage') {
      cancelImg()
    } else {
      cancelAudio()
    }
    setProgress(progressBar, type, 1)
  }

  // 是否上传中
  const [uploading, setuUploading] = useState(true)
  // 设置上传进度
  const setProgress = (progressBar: any, type: string, cancel?: number) => {
    if (progressBar.progress < 100) {
      setuUploading(true)
    } else {
      setuUploading(false)
    }
    let info = {...artworkInfo}
    if (type === 'artworkVideo') {
      info.artworkVideo.progressBar = progressBar
      if (cancel) {
        info.artworkVideo.file = info.artworkVideo.text
        info.artworkVideo.format = ''
        setuUploading(false)
      }
    } else if (type === 'artworkAudio') {
      info.artworkAudio.progressBar = progressBar
    } else {
      info.artworkImage.progressBar = progressBar
      if (cancel) {
        info.artworkImage.file = info.artworkImage.text
        info.artworkImage.format = ''
        setuUploading(false)
      }
    }
    setArtworkInfo(info)
  }

  const checkInfo = (info: any, haveRead: boolean) => {
    setSubmit(false)
    for (const key in info) {
      if (info.hasOwnProperty(key)) {
        const element = info[key]
        if (key !== 'profileLink' && (!element.text || (element.text && +element.text === 0) || element.errShow)) {
          setSubmit(true)
        }
        if (key === 'profileLink' && element.errShow) {
          setSubmit(true)
        }
        if (key === 'royalties' && !!element.text) {
          setSubmit(false)
        }
      }
    }
    if (!haveRead) {
      setSubmit(true)
    }
  }

  const [openErrModal] = useModal(
    <Modal maxWidth={598} backgroundColor={theme.bsBg1} padding={'0px 0 20px 0'}>
      <Text 
        fontSize={20} 
        color={theme.text1} 
        margin="52px 0 32px"
        fontFamily='Baloo Da'
        style={{whiteSpace: 'pre-line', textAlign: 'center'}}
      >
        You do not have permission to create NFT
      </Text>
    </Modal>
  )

  let isV2 = false
  if ([MARKETTYPE.BAKERYBSCARTWORK].includes(type)) {
    isV2 = true
  } else {
    isV2 = false
  }

  // show popup on confirm
  const addPopup = useAddPopup()
  const confirm = async () => {
    setResloading(true)
    let param = {
      nftType: mintType.nftType[type],
      name: artworkInfo.name.text.trim(),
      address: account,
      description: artworkInfo.briefintr.text.trim(),
      fileUrl: curTab.key === 3 ? artworkInfo.artworkVideo.text : curTab.key === 4 ? artworkInfo.artworkAudio.text : artworkInfo.artworkImage.text,
      attributes: {
        cover_url: (curTab.key === 3 || curTab.key === 4) ? artworkInfo.artworkImage.text : '',
        artist: artworkInfo.artistName.text.trim(),
        public_profile_link: artworkInfo.profileLink.text || undefined
      }
    }
    if (isV2) {
      param.attributes['creatorRoyalties'] = +artworkInfo.royalties.text.trim() * 100
    }

    createArtworks(chainId as number, param, (err: any, d: any) => {
      if (err || d.code !== 0) {
        setResloading(false)
        if (d.code === 1304) {
          openErrModal()
        }
        return
      }
      const params = [bakeryArtworkNft, d.data.tokenURI]
      let mintFunction
      if (isV2) {
        mintFunction = mintBakeryArtworkV2
        params.push(param.attributes['creatorRoyalties'])
      } else {
        mintFunction = mintBakeryArtwork
      }
      params.push(account)
      mintFunction(...params).then(res => {
        const hash = (res as any)?.transactionHash
        if (library && hash) {
          const getReceipt = () => {
            library
              .getTransactionReceipt(hash)
              .then(receipt => {
                if (receipt) {
                  setResloading(false)
                  addPopup(
                    {
                      txn: {
                        hash,
                        success: receipt.status === 1,
                        summary: 'Launch Artworks!'
                      }
                    },
                    hash
                  )
                }
              })
              .catch(error => {
                setResloading(false)
                console.error(`failed to check transaction hash: ${hash}`, error)
              })
          }
          getReceipt()
        } else {
          setResloading(false)
        }
      }).catch(err => {
        console.log('err', err)
        setResloading(false)
      })
    })
  }

  return (
    <LaunchWrap>
      <TYPE.mediumHeader
        color={theme.bsText7}
        fontFamily="Baloo Da"
        fontSize={20}
        textAlign="center"
        marginBottom={16}
      >
        1. Artwork information
      </TYPE.mediumHeader>
      <FormItem width="213px">
        <Text fontSize={14} color={theme.bsText15} fontFamily="Yuanti SC" fontWeight="bold" marginBottom={10}>
          Artwork Type
        </Text>
        <SortPets
          height={54}
          top="66px"
          bg={theme.darkMode ? theme.bsBg19 : 'rgba(242, 223, 207, 0.5)'}
          select={theme.bsBg22}
          wd="213px"
          img="../../assets/images/artwork_img.svg"
          curSelect={curTab}
          options={MintOptions}
          updateData={upTab}
        ></SortPets>
      </FormItem>
      <FormItem>
        <LaunchInput 
          info={artworkInfo.name} 
          title="Artwork Name"
          type="name"
          inputChange={inputChange}
          inputBlur={inputBlur}></LaunchInput>
      </FormItem>
      <FormItem>
        <LaunchInput 
          info={artworkInfo.artistName} 
          title="Artist Name"
          type="artistName"
          nameHave={nameHave}
          inputChange={inputChange}
          inputBlur={inputBlur}></LaunchInput>
      </FormItem>
      <FormItem>
        <LaunchInput
          info={artworkInfo.profileLink} 
          title="Social Media/Portfolio link"
          type="profileLink"
          inputChange={inputChange}
          inputBlur={inputBlur}></LaunchInput>
      </FormItem>
      <FormItem height="191px">
        <LaunchInput 
          info={artworkInfo.briefintr} 
          title="Brief Introduction"
          type="briefintr"
          inputType="textarea"
          inputChange={inputChange}
          inputBlur={inputBlur}></LaunchInput>
        {/* <TextareaLimit>{briefNum ? briefNum + ' / ' : ''}500</TextareaLimit> */}
      </FormItem>
      {
        isV2 &&
        <FormItem width={'300px'}>
          <LaunchInput
            info={artworkInfo.royalties} 
            title="Royalties"
            type="royalties"
            inputType2={'number'}
            inputChange={inputChange}
            inputBlur={inputBlur}></LaunchInput>
          <SymbolIcon>%</SymbolIcon>
          <Text fontSize={14} color={theme.bsText2} marginTop={'8px'}>Suggested: 0%, 10%, 20%, 30%</Text>
        </FormItem>
      }
      <TYPE.mediumHeader
        color={theme.bsText7}
        fontFamily="Baloo Da"
        fontSize={20}
        textAlign="center"
        marginTop={28}
        style={{ padding: '40px 0 24px', borderTop: '1px solid' + theme.bsBorder2 }}
      >
        { (fileType === 3 || fileType === 4) ? '2. Upload artwork cover' : '2. Upload artwork image'}
      </TYPE.mediumHeader>
      <FormItem height="auto">
        <LaunchUpload align="flex-start" pad="38px">
          <UpLoadFiles
            info={artworkInfo.artworkImage}
            bgCover={'images/artworks/artwork_image.png'}
            hoverCover={'images/artworks/artwork_image_cover.png'}
            fileType={(fileType !== 3 && fileType !== 4) ? fileType : 1}
            uploadImg={() => {uploadImg('artworkImage')}}
            cancelUpload={() => cancelUpload('artworkImage')}></UpLoadFiles>
          <input
            type="file"
            accept={(curTab.key !== 3 && curTab.key !== 4) ? curTab.accept : '.jpg, .png, .jpeg'}
            id="imgFile"
            className="inputFile"
            onChange={event => {
              uploadIdImg(event, 'artworkImage')
            }}
          />
        </LaunchUpload>
      </FormItem>
      {
        curTab.key === 3 ? (
          <>
            <TYPE.mediumHeader
              color={theme.bsText7}
              fontFamily="Baloo Da"
              fontSize={20}
              textAlign="center"
              marginTop={28}
              style={{ padding: '40px 0 24px', borderTop: '1px solid' + theme.bsBorder2 }}
            >
              3. Upload artwork video
            </TYPE.mediumHeader>
            <FormItem height="auto">
              <LaunchUpload align="flex-start" pad="38px">
                <UpLoadFiles
                  info={artworkInfo.artworkVideo}
                  bgCover={'images/artworks/artwork_video.png'}
                  hoverCover={'images/artworks/artwork_video_cover.png'}
                  fileType={fileType}
                  uploadImg={() => {uploadImg('artworkVideo')}}
                  cancelUpload={() => cancelUpload('artworkVideo')}></UpLoadFiles>
                <input
                  type="file"
                  accept={curTab.accept}
                  id="videoFile"
                  className="inputFile"
                  onChange={event => {
                    uploadIdImg(event, 'artworkVideo')
                  }}
                />
              </LaunchUpload>
            </FormItem>
          </>
        ) : <></>
      }
      {
        curTab.key === 4 ? (
          <>
            <TYPE.mediumHeader
              color={theme.bsText7}
              fontFamily="Baloo Da"
              fontSize={20}
              textAlign="center"
              marginTop={10}
              style={{ padding: '30px 0 24px', borderTop: '1px solid' + theme.bsBorder2 }}
            >
              3. Upload artwork audio
            </TYPE.mediumHeader>
            <FormItem height="auto">
              <LaunchUpload align="flex-start" pad="38px">
                <UpLoadFiles
                  info={artworkInfo.artworkAudio}
                  bgCover={fileType === 3 ? 'images/artworks/artwork_video.png' : 'images/artworks/artwork_image.png'}
                  hoverCover={fileType === 3 ? 'images/artworks/artwork_video_cover.png' : 'images/artworks/artwork_image_cover.png'}
                  fileType={fileType} uploadImg={() => {uploadImg('artworkAudio')}}
                  cancelUpload={() => cancelUpload('artworkAudio')}></UpLoadFiles>
                <input
                  type="file"
                  accept={curTab.accept}
                  id="audioFile"
                  className="inputFile"
                  onChange={event => {
                    uploadIdImg(event, 'artworkAudio')
                  }}
                />
              </LaunchUpload>
            </FormItem>
          </>
        ) : <></>
      }
      <FormItem height="auto">
        <MintCheckbox>
          <input name="checkbox"
            value="Item 1"
            type="checkbox"
            className="tui-checkbox"
            checked={haveRead}
            onChange={handleCheckboxChange} />
          <label onClick={handleCheckboxChange}>I declare that this is an original artwork. I understand that no plagiarism is allowed, and that the artwork can be removed anytime if detected.</label>
        </MintCheckbox>
      </FormItem>
      <TYPE.mediumHeader
        color={theme.bsText7}
        fontSize={12}
        textAlign="center"
        marginBottom={30}
        marginTop={-10}
      >
        { mintType.charges[type] }
      </TYPE.mediumHeader>
      {
        account ? (
          <Button style={{margin: '0 auto'}} onClick={confirm} disabled={!canMint || submit || resloading || uploading} altDisabledStyle={!canMint || submit || resloading || uploading}>
            {
              resloading ? (
                <AutoRow gap="6px" justify="center">
                  pending <Loader stroke="white" />
                </AutoRow>
              ) : 'Mint'
            }
          </Button>
        ) : (
          <Button
            style={{margin: '0 auto'}}
            onClick={toggleWalletModal}>
            Connect Wallet
          </Button>
        )
      }
    </LaunchWrap>
  )
}
